import React from 'react';
import PropTypes from 'prop-types';
import { safeRest } from '@wds/utils';
import { useTheme } from 'react-jss';

import useStyles from './useStyles';

const Pane = ({
  children,
  hide,
  id,
  padding,
  labelledBy,
  role,
  transparent,
  ...rest
}) => {
  const theme = useTheme();
  const classes = useStyles({ hide, transparent, theme });
  return (
    <div
      className={classes.wdsPane}
      role={role}
      id={id}
      aria-labelledby={labelledBy}
      aria-hidden={hide}
      {...safeRest(rest)}
    >
      <Choose>
        <When condition={padding}>
          <div className={classes.wdsPaneBody}>{children}</div>
        </When>
        <Otherwise>{children}</Otherwise>
      </Choose>
    </div>
  );
};

Pane.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    .isRequired,
  hide: PropTypes.bool,
  id: PropTypes.string,
  padding: PropTypes.bool,
  labelledBy: PropTypes.string,
  role: PropTypes.string,
  transparent: PropTypes.bool,
};

Pane.defaultProps = {
  hide: false,
  id: undefined,
  padding: false,
  labelledBy: undefined,
  role: undefined,
  transparent: false,
};

export default Pane;
